/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';

export interface ICittaPaymentAfterpayTabContentProps {
    isBusy?: boolean;
    afterpayAvailable?: boolean;
    afterpayImgSrc: string;
    instalmentAmount: string;
    // tslint:disable-next-line:no-any
    processAfterpayOrder (e:any):Promise<void>;
}

const CittaPaymentAfterpayContentTab = ({
    isBusy,
    afterpayAvailable,
    afterpayImgSrc,
    instalmentAmount,
    processAfterpayOrder
}:ICittaPaymentAfterpayTabContentProps) => {
    const callToActionProps = {
      className: 'btn btn-primary checkout-place-order__btn-place-order',
      title: isBusy ? 'Please wait ' : 'Proceed to Afterpay',
      onClick: processAfterpayOrder,
      glyph: isBusy ? 'spinner' : '',
      disabled: isBusy
    };
    return (
        <div className='ap'>
        {afterpayAvailable && (
          <div className='payment-afterpay-container'>
            <div className='block-title'>
              <img
                src={afterpayImgSrc}
                alt='AfterPay'
              />
            </div>
            <h5>Shop now. Enjoy now. Pay later.</h5>
            <p>Four interest-free payments of <strong>${instalmentAmount}, every 2 weeks</strong></p>
            <div className='instalment-container'>
              <div className='instalment-container'>
                <div className='instalment first'>
                  <div className='icon-container-afterpay first'>
                    <div className='icon'>
                      <div className='progress'><span className='progress-wheel-1'>First payment</span></div>
                    </div>
                  </div>
                  <div className='description'>First payment</div>
                </div>
                <div className='instalment second'>
                  <div className='icon-container-afterpay'>
                    <div className='icon'>
                      <div className='progress'><span className='progress-wheel-2'>Second payment</span></div>
                    </div>
                  </div>
                  <div className='description'>2 weeks</div>
                </div>
              </div>
              <div className='instalment-container'>
                <div className='instalment third'>
                  <div className='icon-container-afterpay'>
                    <div className='icon'>
                      <div className='progress'><span className='progress-wheel-3'>Third payment</span></div>
                    </div>
                  </div>
                  <div className='description'> 4 weeks </div>
                </div>
                <div className='instalment fourth'>
                  <div className='icon-container-afterpay fourth'>
                    <div className='icon'>
                      <div className='progress'><span className='progress-wheel-4'>Fourth payment</span></div>
                    </div>
                  </div>
                  <div className='description'> 6 weeks </div>
                </div>
              </div>
            </div>
            <div className='afterpay-terms'>
              <p>
                <strong>
                  You will be taken to the Afterpay website to complete your order.
                </strong>
              </p>
              <p>
                <a href='https://www.afterpay.com/en-NZ/terms-of-service' target='_blank' className='afterpay-tc'>
                  Learn More
                </a>
              </p>
              <button {...callToActionProps}>
                {isBusy ? 'Please wait ' : 'Proceed to Afterpay'}
              </button>
            </div>
          </div>
        )}
      </div>
    );
};

export default React.memo(CittaPaymentAfterpayContentTab);